import { useCallback, useState } from "react";
import { getApiErrorMessage } from "../../../../lib/result-codes";
import { deleteMerchantCoupon as deleteMerchantCouponApi } from "../api/merchantCouponList.api";

interface UseDeleteMerchantCouponReturn {
  deleteMerchantCoupon: (id: string) => Promise<void>;
  loading: boolean;
  error: string | null;
}

export const useDeleteMerchantCoupon = (): UseDeleteMerchantCouponReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deleteMerchantCoupon = useCallback(async (id: string): Promise<void> => {
    try {
      setLoading(true);
      setError(null);
      await deleteMerchantCouponApi(id);
    } catch (deleteError: unknown) {
      setError(getApiErrorMessage(deleteError, "Failed to delete coupon"));
      throw deleteError;
    } finally {
      setLoading(false);
    }
  }, []);

  return { deleteMerchantCoupon, loading, error };
};
